import {Catalog} from '../../common/types/common';
import {Offer, Wizard} from '../types/mx/catalog';

export const GOT_YEARS_ACTION = {
    name: 'GOT_YEARS_ACTION',
    action: (years: Catalog[], queryStringYear: string) => ({
        years, queryStringYear,
        type: GOT_YEARS_ACTION.name
    })
};

export const GOT_EMPLOYMENT_TYPES_ACTION = {
    name: 'GOT_EMPLOYMENT_TYPES_ACTION',
    action: (employmentTypes: Catalog[]) => ({
        employmentTypes,
        type: GOT_EMPLOYMENT_TYPES_ACTION.name
    })
};

export const GOT_TERMS_ACTION = {
    name: 'GOT_TERMS_ACTION',
    action: terms => ({
        terms,
        type: GOT_TERMS_ACTION.name
    })
};

export const GOT_PROVINCES_ACTION = {
    name: 'GOT_PROVINCES_ACTION',
    action: (provinces, province) => ({
        provinces, province,
        type: GOT_PROVINCES_ACTION.name
    })
};

export const GOT_BRANDS_ACTION = {
    name: 'GOT_BRANDS_ACTION',
    action: (brands, brand: Catalog) => ({
        brands, brand,
        type: GOT_BRANDS_ACTION.name
    })
};

export const GOT_MODELS_ACTION = {
    name: 'GOT_MODELS_ACTION',
    action: (models, model) => ({
        models, model,
        type: GOT_MODELS_ACTION.name
    })
};

export const GOT_VERSIONS_ACTION = {
    name: 'GOT_VERSIONS_ACTION',
    action: (versions, version) => ({
        versions, version,
        type: GOT_VERSIONS_ACTION.name
    })
};

export const GOT_OFFERS_ACTION = {
    name: 'GOT_OFFERS_ACTION',
    action: (offers: Offer[]) => ({
        offers,
        type: GOT_OFFERS_ACTION.name
    })
};

export const GOT_WIZARD_ACTION = {
    name: 'GOT_WIZARD_ACTION',
    action: (wizard: Wizard[]) => ({
        wizard,
        type: GOT_WIZARD_ACTION.name
    })
};

export const GOT_BUREAU_CATALOG_ACTION = {
    name: 'GOT_BUREAU_CATALOG_ACTION',
    action: bureauCatalogs => ({
        bureauCatalogs,
        type: GOT_BUREAU_CATALOG_ACTION.name
    })
};

export const GOT_CHANNEL_REFERENTS_ACTION = {
    name: 'GOT_CHANNEL_REFERENTS_ACTION',
    action: channelReferents => ({
        channelReferents,
        type: GOT_CHANNEL_REFERENTS_ACTION.name
    })
};

export const GOT_CIVIL_STATUS_ACTION = {
    name: 'GOT_CIVIL_STATUS_ACTION',
    action: civilStatus => ({
        civilStatus,
        type: GOT_CIVIL_STATUS_ACTION.name
    })
};

export const GOT_REGIME_ACTION = {
    name: 'GOT_REGIME_ACTION',
    action: regime => ({
        regime,
        type: GOT_REGIME_ACTION.name
    })
};

export const GOT_ROL_HOME_ACTION = {
    name: 'GOT_ROL_HOME_ACTION',
    action: rolHome => ({
        rolHome,
        type: GOT_ROL_HOME_ACTION.name
    })
};

export const GOT_STUDIES_ACTION = {
    name: 'GOT_STUDIES_ACTION',
    action: studies => ({
        studies,
        type: GOT_STUDIES_ACTION.name
    })
};

export const GOT_ASSEMBLY_COUNTRY_ACTION = {
    name: 'GOT_ASSEMBLY_COUNTRY_ACTION',
    action: assemblyCountry => ({
        assemblyCountry,
        type: GOT_ASSEMBLY_COUNTRY_ACTION.name
    })
};

export const GOT_HOUSE_TYPE_ACTION = {
    name: 'GOT_HOUSE_TYPE_ACTION',
    action: houseType => ({
        houseType,
        type: GOT_HOUSE_TYPE_ACTION.name
    })
};

export const GOT_LAPSE_ACTION = {
    name: 'GOT_LAPSE_ACTION',
    action: lapse => ({
        lapse,
        type: GOT_LAPSE_ACTION.name
    })
};

export const GOT_EMPLOYMENT_ROTATION_ACTION = {
    name: 'GOT_EMPLOYMENT_ROTATION_ACTION',
    action: employmentRotation => ({
        employmentRotation,
        type: GOT_EMPLOYMENT_ROTATION_ACTION.name
    })
};

export const GOT_EMPLOYMENT_BILLING_TYPES_ACTION = {
    name: 'GOT_EMPLOYMENT_BILLING_TYPES_ACTION',
    action: billingTypes => ({
        billingTypes,
        type: GOT_EMPLOYMENT_BILLING_TYPES_ACTION.name
    })
};

export const GOT_EMPLOYMENT_TAX_REGIMES_ACTION = {
    name: 'GOT_EMPLOYMENT_TAX_REGIMES_ACTION',
    action: taxRegimes => ({
        taxRegimes,
        type: GOT_EMPLOYMENT_TAX_REGIMES_ACTION.name
    })
};

export const GOT_ALL_QUOTATION_INSURANCES_ACTION = {
    name: 'GOT_ALL_QUOTATION_INSURANCES_ACTION',
    action: insurances => ({
        insurances,
        type: GOT_ALL_QUOTATION_INSURANCES_ACTION.name
    })
};

export const GOT_ALL_CATALOGS_SUCCESSFULLY = {
    name: 'GOT_ALL_CATALOGS_SUCCESSFULLY',
    action: () => ({
        type: GOT_ALL_CATALOGS_SUCCESSFULLY.name
    })
};

export const GOT_CR_GENDER_ACTION = {
    name: 'GOT_CR_GENDER_ACTION',
    action: gender => ({
        gender,
        type: GOT_CR_GENDER_ACTION.name
    })
};

export const GOT_CR_CIVIL_STATUS_ACTION = {
    name: 'GOT_CR_CIVIL_STATUS_ACTION',
    action: civilStatus => ({
        civilStatus,
        type: GOT_CR_CIVIL_STATUS_ACTION.name
    })
};

export const GOT_CR_STUDIES_LEVEL_ACTION = {
    name: 'GOT_CR_STUDIES_LEVEL_ACTION',
    action: studiesLevel => ({
        studiesLevel,
        type: GOT_CR_STUDIES_LEVEL_ACTION.name
    })
};

export const GOT_CR_COUNTRIES_WITH_NATIONALITIES_ACTION = {
    name: 'GOT_CR_COUNTRIES_WITH_NATIONALITIES_ACTION',
    action: (countriesWithNationalities: Catalog[]) => ({
        countriesWithNationalities,
        type: GOT_CR_COUNTRIES_WITH_NATIONALITIES_ACTION.name
    })
};

export const GOT_CR_HOUSE_TYPE_ACTION = {
    name: 'GOT_CR_HOUSE_TYPE_ACTION',
    action: houseType => ({
        houseType,
        type: GOT_CR_HOUSE_TYPE_ACTION.name
    })
};

export const GOT_CR_DOCUMENT_TYPE_ACTION = {
    name: 'GOT_CR_DOCUMENT_TYPE_ACTION',
    action: documentType => ({
        documentType,
        type: GOT_CR_DOCUMENT_TYPE_ACTION.name
    })
};

export const GOT_CR_BUSINESS_TYPE_ACTION = {
    name: 'GOT_CR_BUSINESS_TYPE_ACTION',
    action: businessType => ({
        businessType,
        type: GOT_CR_BUSINESS_TYPE_ACTION.name
    })
};
